import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "manage-tenants" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  class: "search",
  for: "search-tenant"
}
const _hoisted_4 = ["onKeydown"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4 4L16 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 4L4 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "filters" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M16.0399 3.01976L8.15988 10.8998C7.85988 11.1998 7.55988 11.7898 7.49988 12.2198L7.06988 15.2298C6.90988 16.3198 7.67988 17.0798 8.76988 16.9298L11.7799 16.4998C12.1999 16.4398 12.7899 16.1398 13.0999 15.8398L20.9799 7.95976C22.3399 6.59976 22.9799 5.01976 20.9799 3.01976C18.9799 1.01976 17.3999 1.65976 16.0399 3.01976Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.9102 4.1499C15.5802 6.5399 17.4502 8.4099 19.8502 9.0899",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "tenants"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "tenants-title doc-grid" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Tenant")
  ]),
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Setor")
  ]),
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Usuários")
  ]),
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Documentos")
  ]),
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Ações")
  ])
], -1)
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "actions" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11.89 5.05078C12.0996 6.39164 12.7486 7.62492 13.735 8.55703C14.7214 9.48914 15.9894 10.0673 17.34 10.2008M3 22.0008H21",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "no-options"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", null, "Nenhum tenant encontrado", -1)
const _hoisted_22 = [
  _hoisted_21
]

import { onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import { TenantModel } from '@/models/TenantModel'
import { tenantSectorLabels } from '@/enums/Tenants/TenantSectorEnum'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'

interface TenantWithCounts extends TenantModel {
  users_count: number
  documents_count: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageTenantsView',
  setup(__props) {

const axios = useAxios()
const tenants = ref<TenantWithCounts[]>()
const filter = ref<{ search?: string }>({})

onMounted(() => {
  getTenants()
})

function getTenants () {
  tenants.value = undefined
  axios.get('/api/platform-admin/tenants', { params: filter.value })
    .then((res: AxiosResponse<TenantWithCounts[]>) => {
      tenants.value = res.data
    })
    .catch(() => {
      tenants.value = []
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          autocomplete: "off",
          type: "text",
          placeholder: "Buscar por nome ou sigla",
          id: "search-tenant",
          name: "search-tenant",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter.value.search) = $event)),
          onKeydown: _withKeys(_withModifiers(getTenants, ["prevent"]), ["enter"])
        }, null, 40, _hoisted_4), [
          [_vModelText, filter.value.search]
        ]),
        (!filter.value.search)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 0,
              onClick: getTenants,
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none"
            }, _hoisted_6))
          : (_openBlock(), _createElementBlock("svg", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => {filter.value.search = ''; getTenants()}),
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none"
            }, _hoisted_9))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "tooltip",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'platform-admin.tenants.create' })))
        }, _hoisted_12)
      ])
    ]),
    (tenants.value && tenants.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenants.value, (tenant) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "tenants-list doc-grid",
              key: tenant.id
            }, [
              _createElementVNode("label", _hoisted_15, [
                _createElementVNode("h1", null, _toDisplayString(tenant.name), 1),
                _createElementVNode("h2", null, _toDisplayString(tenant.acronym), 1)
              ]),
              _createElementVNode("label", null, [
                _createElementVNode("h1", null, _toDisplayString(_unref(tenantSectorLabels)[tenant.sector] ?? tenant.sector), 1)
              ]),
              _createElementVNode("label", null, [
                _createElementVNode("h1", null, _toDisplayString(tenant.users_count), 1)
              ]),
              _createElementVNode("label", null, [
                _createElementVNode("h1", null, _toDisplayString(tenant.documents_count), 1)
              ]),
              _createElementVNode("label", _hoisted_16, [
                _createElementVNode("button", {
                  class: "tooltip",
                  onClick: ($event: any) => (_ctx.$router.push({ name: 'platform-admin.tenants.edit', params: { id: tenant.id } }))
                }, _hoisted_19, 8, _hoisted_17)
              ])
            ]))
          }), 128))
        ]))
      : (tenants.value && !tenants.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
        : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 }))
  ]))
}
}

})